import axiosInstance from '@/services/axiosInstance'

async function linkGroupToNEO (payload = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve()
    })
  } else {
    const req = {
      url: 'api/grupos/linkneo',
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: payload
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { linkGroupToNEO }
